module.exports = __webpack_public_path__ + "static/a-xx-119-art-dbf24af5502e1420d8c3f28528fbcb64.jpg";